function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "C315BCA1-B991-414A-A4F3-A2FAC55C40A7");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FOOTER_DESKTOP",
  transform: "translate(-352.000000, -102.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M381.121804,104.763789 C380.069411,105.232656 378.93821,105.5494 377.751229,105.691899 C378.962811,104.962454 379.893488,103.80738 380.33158,102.430944 C379.197518,103.106521 377.941598,103.596936 376.604724,103.861248 C375.53431,102.715655 374.00907,102 372.321065,102 C369.080072,102 366.452237,104.638959 366.452237,107.894024 C366.452237,108.355996 366.504156,108.805902 366.604132,109.237277 C361.726624,108.991495 357.402345,106.64486 354.507907,103.078797 C354.002735,103.949304 353.713249,104.961736 353.713249,106.041969 C353.713249,108.086943 354.749336,109.891019 356.324064,110.947981 C355.361921,110.917384 354.457132,110.65221 353.665907,110.21078 C353.665335,110.235343 353.665335,110.260051 353.665335,110.284902 C353.665335,113.140625 355.688309,115.522885 358.373069,116.064438 C357.880627,116.19918 357.362154,116.271148 356.826804,116.271148 C356.448498,116.271148 356.080918,116.234086 355.722492,116.165423 C356.469522,118.50703 358.636668,120.21127 361.204861,120.258674 C359.196333,121.839665 356.665899,122.781852 353.916204,122.781852 C353.442498,122.781852 352.975372,122.753985 352.516255,122.699398 C355.113483,124.371893 358.198433,125.347838 361.512512,125.347838 C372.307191,125.347838 378.210203,116.366386 378.210203,108.577357 C378.210203,108.321808 378.204482,108.067694 378.193182,107.81473 C379.340116,106.98387 380.335012,105.945725 381.121804,104.763789 L381.121804,104.763789 Z",
  id: "Shape-5-Copy"
})));

var SvgEroskiFooter2Twitter = function SvgEroskiFooter2Twitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "24px",
    viewBox: "0 0 30 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter2Twitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer2-twitter.5608e756.svg";
export { ForwardRef as ReactComponent };